import {
  extrasNoteLines,
  extrasTableRows,
  extrasHorizontalRows,
  GC_EXTRAS_SOURCE
} from './gcIndirectExtras';

export function downloadBlob(filename, blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function styleHeaderRow(ws, argb = 'FF0F766E') {
  const header = ws.getRow(1);
  header.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  header.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb } };
  header.alignment = { vertical: 'middle' };
  ws.views = [{ state: 'frozen', ySplit: 1, xSplit: 1 }];
}

export function addHorizontalWorksheet(wb, {
  name = 'By date',
  rowHeader = 'Item',
  columns = [],
  rows = [],
  argb = 'FF0F766E'
} = {}) {
  const ws = wb.addWorksheet(String(name).slice(0, 31));
  ws.addRow([rowHeader, ...columns]);
  rows.forEach((row) => {
    ws.addRow([row.label, ...(row.values || [])]);
  });
  styleHeaderRow(ws, argb);
  ws.getColumn(1).width = 36;
  columns.forEach((_, i) => { ws.getColumn(i + 2).width = 11; });
  return ws;
}

export function addHorizontalPdfTables(doc, autoTable, {
  title,
  columns = [],
  rows = [],
  startY,
  headColor = [15, 118, 110],
  chunk = 10
} = {}) {
  if (!columns.length || !rows.length) return startY;
  let y = startY;
  const pageW = doc.internal.pageSize.getWidth();
  if (title) {
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    doc.text(title, 14, y);
    y += 5;
  }
  for (let i = 0; i < columns.length; i += chunk) {
    if (y > doc.internal.pageSize.getHeight() - 28) {
      doc.addPage();
      y = 16;
    }
    const cols = columns.slice(i, i + chunk);
    autoTable(doc, {
      startY: y,
      head: [['', ...cols]],
      body: rows.map((r) => [r.label, ...(r.values || []).slice(i, i + chunk)]),
      styles: { fontSize: 6.5, cellPadding: 1, halign: 'right' },
      columnStyles: { 0: { halign: 'left', cellWidth: Math.min(52, pageW * 0.28), fontStyle: 'bold' } },
      headStyles: { fillColor: headColor, fontSize: 6.5, halign: 'center' },
      alternateRowStyles: { fillColor: [248, 250, 252] },
      tableWidth: 'auto'
    });
    y = doc.lastAutoTable.finalY + 5;
  }
  return y;
}

export function addExtrasWorksheet(wb, {
  jobNumber, cfg, name = 'GC extras', projectMonths = 0, months = []
} = {}) {
  const ws = wb.addWorksheet(name);
  ws.columns = [
    { header: 'Code', key: 'id', width: 10 },
    { header: 'Category', key: 'category', width: 32 },
    { header: 'Cost item', key: 'name', width: 52 },
    { header: 'Unit', key: 'unit', width: 14 },
    { header: 'Qty', key: 'qty', width: 10 },
    { header: 'Duration (months)', key: 'duration', width: 16 },
    { header: 'Qty × months', key: 'total', width: 14 },
    { header: 'Kind', key: 'kind', width: 10 }
  ];
  extrasTableRows(cfg, projectMonths).forEach((row) => {
    ws.addRow({
      id: row[0],
      category: row[1],
      name: row[2],
      unit: row[3],
      qty: row[4],
      duration: row[5],
      total: row[6],
      kind: row[7]
    });
  });
  styleHeaderRow(ws, 'FF7C3AED');
  if (months.length) {
    addHorizontalWorksheet(wb, {
      name: 'GC extras by month',
      rowHeader: 'Cost item',
      columns: months,
      rows: extrasHorizontalRows(cfg, months, projectMonths),
      argb: 'FF7C3AED'
    });
  }
  const notes = wb.addWorksheet('Extras notes');
  notes.getColumn(1).width = 96;
  extrasNoteLines(jobNumber, projectMonths).forEach((line, i) => { notes.getCell(i + 1, 1).value = line; });
  notes.getCell(extrasNoteLines(jobNumber, projectMonths).length + 2, 1).value = GC_EXTRAS_SOURCE;
  return ws;
}

export const exportChip = (label, onClick, { solid = false, disabled = false } = {}) => ({
  type: 'button',
  onClick,
  disabled,
  children: label,
  style: {
    border: '1px solid #0f766e',
    background: solid ? '#0f766e' : 'white',
    color: solid ? 'white' : '#0f766e',
    borderRadius: 7,
    fontSize: '0.75rem',
    fontWeight: 800,
    padding: '0.35rem 0.7rem',
    cursor: disabled ? 'wait' : 'pointer',
    whiteSpace: 'nowrap'
  }
});
